export default __webpack_public_path__ + "static/media/room2_main.94cc3207.jpg";